import { EnvironmentOptions } from './environment-options';
import { GOOGLE_PRODUCTS } from './google-products';

export const environment: EnvironmentOptions = {
  production: true,
  baseUrl: 'https://rpdac.realpage.com/dac',
  baseCdnUrl: 'https://cs-cdn.realpage.com/EXPLORE',
  propertyCdnUrl: 'https://cs-cdn.realpage.com/EXPLORE/property',
  assetOptimizationURL: 'https://ao.realpage.com/ysconfig',
  authCookieName: 'AOCookieProd',
  authTokenName: 'SSOTokenProd',
  useCookie: true,
  underwriterUrl: 'https://www.realpage.com/uw',
  agGridLicenseKey: 'RealPage_Inc_MultiApp_1Devs2_SaaS_7_September_2018__MTUzNjI3NDgwMDAwMA==19ba64bb8eeb8a1dce779512ef96a3cb',
  paymentGatewayUrl: 'https://dac.realpage.com/dapg',
  staticFiles: 'assets',
  redirect: 'https://www.realpage.com/explore',

  useAnalytics: true,
  analyticsId: GOOGLE_PRODUCTS.ANALYTICS.REALPAGE_DEV_ACCOUNT,
  reCaptchaKey: GOOGLE_PRODUCTS.RECAPTCHA.SITE_KEY
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts